"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _queries = require("./queries");

var createOrganisation = function createOrganisation() {
  return {
    mutation: _queries.createOrganisationQuery,
    module: 'organisations',
    buildVariables: function buildVariables(input) {
      return {
        input: input
      };
    }
  };
};

var _default = createOrganisation;
exports.default = _default;